import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

const messages = defineMessages({
  blockTitle: {
    id: 'Contact card',
    defaultMessage: 'Contact card',
  },
  contentFieldset: {
    id: 'Content',
    defaultMessage: 'Content',
  },
  ctaFieldset: {
    id: 'Call to action',
    defaultMessage: 'Call to action',
  },
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  text: {
    id: 'Text',
    defaultMessage: 'Text',
  },
  ctaLabel: {
    id: 'Button label',
    defaultMessage: 'Button label',
  },
  email: {
    id: 'Email',
    defaultMessage: 'Email',
  },
});

const ContactCardSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.blockTitle),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.contentFieldset),
      fields: ['title', 'text'],
    },
    {
      id: 'cta',
      title: intl.formatMessage(messages.ctaFieldset),
      fields: ['ctaLabel', 'email'],
    },
  ],
  properties: {
    title: {
      title: intl.formatMessage(messages.title),
      type: 'string',
    },
    text: {
      title: intl.formatMessage(messages.text),
      type: 'string',
      widget: 'textarea',
    },
    ctaLabel: {
      title: intl.formatMessage(messages.ctaLabel),
      type: 'string',
    },
    email: {
      title: intl.formatMessage(messages.email),
      type: 'string',
      widget: 'email',
    },
  },
  required: [],
});

export default ContactCardSchema;
